import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule, UIElementModule, MaterialModule } from './core';
import { UsersModule } from './users';
import { RouterModule } from '@angular/router';
import { routes } from './routes';
import { DashboardModule } from './dashboard';
import { ExerciceModule } from './exercice';
import { TrainingModule } from './training';
import { AutoGeneratedComponent } from './auto-generated/auto-generated.component';

@NgModule({
	declarations: [
		AppComponent,
		AutoGeneratedComponent
	],
	imports: [
		AppRoutingModule,
		HttpClientModule,
		CoreModule,
		UsersModule,
		ExerciceModule,
		TrainingModule,
		DashboardModule
	],
	providers: [],
	bootstrap: [AppComponent,]
})
export class AppModule { }
